import { createReducer, on } from '@ngrx/store';
import {
  setCatalogBreadCrumb,
  setCatalogData,
  setCatalogGroupData,
  setCatalogProductData,
  setCatalogTabsHeader,
  setCatalogPanel,
  setCatalogUrlParams,
  setCatalogFirstLevelData,
  setCatalogCart,
  setCatalogComparator,
  setCatalogFilters
} from './catalog.actions';
import { CatalogElementSelected, CatalogPagination, CatalogUrlParams } from '@/app/_core/domain/models/catalog/catalog.model';
import { Tabs } from '@/app/_core/domain/models/components/tabs/tabs.model';

export interface CatalogState {
  catalogBreadCrumb: CatalogElementSelected[];
  catalogTabsHeader: Tabs[];
  catalogUrlParams: CatalogUrlParams;
  catalogData: CatalogPagination;
  catalogGroupData: CatalogPagination;
  catalogProductData: CatalogPagination;
  catalogFirstLevelData: CatalogPagination;
  catalogPanel: CatalogElementSelected;
  catalogComparator: CatalogElementSelected;
  catalogCart: CatalogElementSelected;
  catalogFilters: unknown;
}

export const initialCatalogState: CatalogState = {
  catalogBreadCrumb: null,
  catalogTabsHeader: null,
  catalogUrlParams: null,
  catalogProductData: null,
  catalogGroupData: null,
  catalogData: null,
  catalogFirstLevelData: null,
  catalogPanel: null,
  catalogComparator: null,
  catalogCart: null,
  catalogFilters: null
};

export const reducer = createReducer<CatalogState>(
  initialCatalogState,
  on(setCatalogBreadCrumb, (state, action) => ({
    ...state,
    catalogBreadCrumb: action.payload.catalogBreadCrumb
  })),
  on(setCatalogTabsHeader, (state, action) => ({
    ...state,
    catalogTabsHeader: action.payload.catalogTabsHeader
  })),
  on(setCatalogUrlParams, (state, action) => ({
    ...state,
    catalogUrlParams: action.payload.catalogUrlParams
  })),
  on(setCatalogData, (state, action) => ({
    ...state,
    catalogData: action.payload.catalogData
  })),
  on(setCatalogGroupData, (state, action) => ({
    ...state,
    catalogGroupData: action.payload.catalogGroupData
  })),
  on(setCatalogProductData, (state, action) => ({
    ...state,
    catalogProductData: action.payload.catalogProductData
  })),
  on(setCatalogFirstLevelData, (state, action) => ({
    ...state,
    catalogFirstLevelData: action.payload.catalogFirstLevelData
  })),
  on(setCatalogPanel, (state, action) => ({
    ...state,
    catalogPanel: action.payload.panel
  })),
  on(setCatalogComparator, (state, action) => ({
    ...state,
    catalogComparator: action.payload.comparator
  })),
  on(setCatalogCart, (state, action) => ({
    ...state,
    catalogCart: action.payload.catalogCart
  })),
  on(setCatalogFilters, (state, action) => ({
    ...state,
    catalogFilters: action.payload.filters
  }))
);
